import { _throwNotImplementedException } from './COM';
import { Rs232DisplayAdapter } from './Rs232DisplayAdapter';
import { Rs232Reply } from './Rs232Reply';
import { $ } from '../../../vendor/jquery';
import { objectHasOwnProperty } from '../../Utility';
import _ from 'underscore';

// <editor-fold desc="Enumerations">

// <editor-folder desc="LgCommandType">
/**
 * Enumeration for command type field in LgCommandType
 * @readonly
 * @enum {Uint8Array}
 */
var LgCommandType = {
    // this command does not work (even though from manual)
    //GetSerialNo: new Uint8Array([ 0x66, 0x79 ]),
    GetSerialNo: new Uint8Array([0x64, 0x7a]), // using check time elapsed command instead
    // no get model command for lg
    //GetModelName: new Uint8Array([ 0x67, 0x7a ]),
    SetPowerState: new Uint8Array([0x6b, 0x61]), // full power off
    SetMuted: new Uint8Array([0x6b, 0x65]),
    SetVolume: new Uint8Array([0x6b, 0x66]),
    SetVideoInput: new Uint8Array([0x78, 0x62]),
};
// </editor-fold>

// <editor-folder desc="LgPowerState">
/**
 * Enumeration for power state commands
 * @readonly
 * @enum {Uint8Array}
 */
var LgPowerState = {
    On: new Uint8Array([0x30, 0x31]), // '0' - '1'
    Off: new Uint8Array([0x30, 0x30]), // '0' - '0'
};
// </editor-fold>

// <editor-folder desc="LgInput">
/**
 * Enumeration for inputs
 * @readonly
 * @enum {number}
 */
var LgInput = {
    AV: '20',
    Component: '40',
    RGB: '60',
    HDMI: '90',
    HDMI2: 'A0',
    HDMI3: '91',
    HDMI4: 'A1',
    DVI: '70',
    DVI2: '80',
    DisplayPort: 'C0',
    DisplayPort2: 'D0',
    parseInt: function (value) {
        for (var prop in LgInput) {
            if (objectHasOwnProperty(LgInput, prop) && LgInput[prop] === value) {
                return prop;
            }
        }

        return 'unknown';
    },
};
// </editor-fold>

// <editor-folder desc="LgMuteState">
/**
 * Enumeration for mute state
 * @readonly
 * @enum {Uint8Array}
 */
var LgMuteState = {
    Unmute: new Uint8Array([0x30, 0x31]), // '0' - '1'
    Mute: new Uint8Array([0x30, 0x30]), // '0' - '0'
};
// </editor-fold>

// </editor-fold>

// <editor-fold desc="LgRs232Reply Abstract Class">

/**
 * Generic Rs232Reply for Lg displays, represents a reply packet from the
 * display
 * @class
 * @param {number[]} bytes - the bytes received from the display
 */
function LgRs232Reply(bytes) {
    Rs232Reply.call(this, bytes);

    if (bytes.length < 8) {
        throw new Error('invalid packet from LG display: response must be at least 8 bytes');
    }

    var packetParts = this.packetString.split(' ');

    if (packetParts.length < 3) {
        throw new Error('invalid packet from LG display: no data returned');
    }

    this.message = packetParts[2].slice(0, packetParts[2].length - 1);
}

LgRs232Reply.prototype = Object.create(Rs232Reply.prototype);
LgRs232Reply.prototype.constructor = LgRs232Reply;

LgRs232Reply.prototype.verifyPacket = function () {
    if (this.message.length < 1) {
        throw new Error('invalid packet from LG display: no message returned');
    }
};

LgRs232Reply.prototype.toString = _throwNotImplementedException('LgRs232Reply.toString');
// </editor-fold>

// <editor-fold desc="LgGetModelReply Class">
function LgGetSerialNumberReply(bytes) {
    LgRs232Reply.call(this, bytes);

    // serial number reply begins with OK or NG
    if (this.message.slice(0, 2) !== 'OK' && this.message.slice(0, 2) !== 'NG') {
        throw 'Com port reply is not that of a LG player';
    }

    //verify the packet integrity
    this.verifyPacket();
}

LgGetSerialNumberReply.prototype = Object.create(LgRs232Reply.prototype);
LgGetSerialNumberReply.prototype.constructor = LgGetSerialNumberReply;

LgGetSerialNumberReply.prototype.toString = function () {
    return this.message;
};
// </editor-fold>

// <editor-fold desc="LgGenericReply Class">
function LgGenericReply(bytes) {
    LgRs232Reply.call(this, bytes);

    //verify the packet integrity
    this.verifyPacket();

    this.success = true;
}

LgGenericReply.prototype = Object.create(LgRs232Reply.prototype);
LgGenericReply.prototype.constructor = LgGenericReply;

LgGenericReply.prototype.toString = function () {
    return this.success;
};
// </editor-fold>

// <editor-fold desc="LgCommand Class">
function LgCommand(command, data) {
    LgPacket.call(this);

    this.command = command;

    this.data = data;
}

LgCommand.prototype = Object.create(LgPacket.prototype);
LgCommand.prototype.constructor = LgCommand;

// <editor-fold desc="LgPacket">
function LgPacket() {
    this.command = new Uint8Array(2);
    this.space = 0x20;

    this.setID = new Uint8Array([0x30, 0x30]); // '0' '0' // Indicates which tv to communicate to (00 means talk to all)

    this.data = new Uint8Array([0x30, 0x30]); // default to ascii string '00'

    this.endOfMessage = 0x0d; // \r to indicate end of message/packet
}

LgPacket.prototype.toUint8Array = function () {
    var i;

    var payload = new Uint8Array(2 + 1 + 2 + 1 + 2 + 1); // (9 total) format: command + space + setID + space + data + return

    for (i = 0; i < this.command.length; ++i) {
        payload[i] = this.command[i];
    }

    payload[2] = this.space;

    for (i = 0; i < this.setID.length; ++i) {
        payload[3 + i] = this.setID[i];
    }

    payload[5] = this.space;

    for (i = 0; i < this.data.length; ++i) {
        payload[6 + i] = this.data[i];
    }

    payload[8] = this.endOfMessage;

    return payload;
};
// </editor-fold>

/**
 * Generic LgRs232DisplayAdapter
 * @class
 * @param {string} displayMake - the vendor name of the hardware display
 * @param {string|null} displayModel - the model of the display
 * @param {Rs232Controller} rs232Controller - controller for interacting with
 * COM port
 */
function LgRs232DisplayAdapter(displayMake, displayModel, rs232Controller) {
    this.make = 'Lg';

    this.model = displayModel;

    this.controller = rs232Controller;
}

LgRs232DisplayAdapter.prototype = Object.create(Rs232DisplayAdapter.prototype);
LgRs232DisplayAdapter.prototype.constructor = LgRs232DisplayAdapter;

// <editor-fold desc="Rs232DisplayAdapter Methods">

LgRs232DisplayAdapter.prototype.getModel = function () {
    // just use get serial number command because lg does not have a command to
    // return the model
    return this.getSerialNumber();
};

LgRs232DisplayAdapter.prototype.getSerialNumber = function () {
    var jqDeferred = $.Deferred();

    this.waitForIdle().then(
        function () {
            //this.setPowerState('on').then(function () {
            this.controller.write(
                new LgCommand(
                    LgCommandType.GetSerialNo,
                    new Uint8Array([0x66, 0x66])
                ).toUint8Array()
            );

            setTimeout(
                function () {
                    Promise.resolve()
                        .then(
                            function () {
                                return this.controller.read(10);
                            }.bind(this)
                        )
                        .then(
                            function (response) {
                                var result = new LgGetSerialNumberReply(response);

                                jqDeferred.resolve(result);
                            }.bind(this)
                        );
                }.bind(this),
                100
            );
        }.bind(this),
        jqDeferred.reject
    );

    return jqDeferred.promise();
};

LgRs232DisplayAdapter.prototype.setPowerState = function (desiredPowerState) {
    var jqDeferred = $.Deferred();

    this.waitForIdle().then(
        function () {
            desiredPowerState = desiredPowerState.toLowerCase();
            if (desiredPowerState !== 'on' && desiredPowerState !== 'off') {
                jqDeferred.reject(
                    'invalid requested power state `' +
                        desiredPowerState +
                        '`. must be either `on` or `off`'
                );
            }

            this.controller.write(
                new LgCommand(
                    LgCommandType.SetPowerState,
                    desiredPowerState === 'on' ? LgPowerState.On : LgPowerState.Off
                ).toUint8Array()
            );

            setTimeout(
                function () {
                    Promise.resolve()
                        .then(
                            function () {
                                return this.controller.read(10);
                            }.bind(this)
                        )
                        .then(
                            function (response) {
                                try {
                                    var result = new LgGenericReply(response);
                                } catch (error2) {
                                    jqDeferred.reject(error2);
                                    return;
                                }

                                // sometimes the view sonic command reply fails, but the power
                                // state is set, so we want to set the refractory first
                                this.setRefractoryPeriod(1000);

                                if (!result.success) {
                                    jqDeferred.reject(
                                        'PowerControl Lg command failed with error code `' +
                                            result.resultCode +
                                            '`'
                                    );
                                    return;
                                }

                                jqDeferred.resolve(result);
                            }.bind(this)
                        );
                }.bind(this),
                100
            );
        }.bind(this),
        jqDeferred.reject
    );

    return jqDeferred.promise();
};

LgRs232DisplayAdapter.prototype.setMuted = function (desiredMuteState) {
    var jqDeferred = $.Deferred();

    this.waitForIdle().then(
        function () {
            desiredMuteState = desiredMuteState.toLowerCase();
            if (desiredMuteState !== 'mute' && desiredMuteState !== 'unmute') {
                jqDeferred.reject(
                    'invalid requested mute state `' +
                        desiredMuteState +
                        '`. must be either `mute` or `unmute`'
                );
            }

            this.controller.write(
                new LgCommand(
                    LgCommandType.SetMuted,
                    desiredMuteState === 'mute' ? LgMuteState.Mute : LgMuteState.Unmute
                ).toUint8Array()
            );

            setTimeout(
                function () {
                    Promise.resolve()
                        .then(
                            function () {
                                return this.controller.read(10);
                            }.bind(this)
                        )
                        .then(
                            function (response) {
                                var result = new LgGenericReply(response);

                                jqDeferred.resolve(result);
                            }.bind(this)
                        );
                }.bind(this),
                100
            );
        }.bind(this),
        jqDeferred.reject
    );

    return jqDeferred.promise();
};

LgRs232DisplayAdapter.prototype.setAudioVolume = function (desiredAudioVolume) {
    var jqDeferred = $.Deferred();

    this.waitForIdle().then(
        function () {
            desiredAudioVolume = parseInt(desiredAudioVolume);

            return Promise.resolve()
                .then(function () {
                    return { maximumValue: 100 };
                })
                .then(
                    function (getAudioVolumeResponse) {
                        var maximumAudioValue = getAudioVolumeResponse.maximumValue;

                        if (desiredAudioVolume < 0 || desiredAudioVolume > maximumAudioValue) {
                            jqDeferred.reject(
                                'invalid requested volume `' +
                                    desiredAudioVolume +
                                    '`. must be between 0 and ' +
                                    maximumAudioValue
                            );
                        }

                        // convert to command parameters in ASCII
                        desiredAudioVolume = desiredAudioVolume.toString(16); // LG expects volume in hex
                        desiredAudioVolume = ('00' + desiredAudioVolume).substring(
                            desiredAudioVolume.length
                        ); // pad left with 0's
                        desiredAudioVolume = new Uint8Array(
                            _.map(desiredAudioVolume.split(''), function (character) {
                                return character.charCodeAt(0);
                            })
                        );

                        this.controller.write(
                            new LgCommand(
                                LgCommandType.SetVolume,
                                desiredAudioVolume
                            ).toUint8Array()
                        );

                        setTimeout(
                            function () {
                                Promise.resolve()
                                    .then(
                                        function () {
                                            return this.controller.read(10);
                                        }.bind(this)
                                    )
                                    .then(
                                        function (response) {
                                            var result = new LgGenericReply(response);

                                            jqDeferred.resolve(result);
                                        }.bind(this)
                                    );
                            }.bind(this),
                            100
                        );
                    }.bind(this)
                );
        }.bind(this),
        jqDeferred.reject
    );

    return jqDeferred.promise();
};

LgRs232DisplayAdapter.prototype.setVideoInput = function (desiredVideoInput) {
    var jqDeferred = $.Deferred();

    this.waitForIdle().then(
        function () {
            return Promise.resolve().then(
                function () {
                    if (!LgInput[desiredVideoInput]) {
                        jqDeferred.reject(
                            'invalid requested input `' +
                                desiredVideoInput +
                                '`. Must be one of LgInput enumeration.'
                        );
                    }

                    //encode desiredAudioVolume as ASCII characters
                    desiredVideoInput = LgInput[desiredVideoInput].toString();
                    desiredVideoInput = new Uint8Array(
                        _.map(desiredVideoInput.split(''), function (character) {
                            return character.charCodeAt(0);
                        })
                    );

                    this.controller.write(
                        new LgCommand(LgCommandType.SetVideoInput, desiredVideoInput).toUint8Array()
                    );

                    //NOTE: this command can take quite some time if switching to VGA
                    this.controller.readTimeout = 5000;

                    setTimeout(
                        function () {
                            Promise.resolve()
                                .then(
                                    function () {
                                        return this.controller.read(10);
                                    }.bind(this)
                                )
                                .then(
                                    function (response) {
                                        var result = new LgGenericReply(response);

                                        jqDeferred.resolve(result);
                                    }.bind(this)
                                );
                        }.bind(this),
                        100
                    );
                }.bind(this)
            );
        }.bind(this),
        jqDeferred.reject
    );

    return jqDeferred.promise();
};

// </editor-fold>

// does not deviate from the default, this is just here to serve as an example
// as this functionality is not yet used anywhere: change the com port settings
// prior to connection when using the view sonic adaptor
LgRs232DisplayAdapter.comSettings = {
    baudRate: 9600,
};

//tell the Rs232DisplayAdapter service about the "Lg" brand of displays
Rs232DisplayAdapter.registerVendorAdapter('lg', LgRs232DisplayAdapter);

export { LgRs232DisplayAdapter };
